// Admin > Companies: the Service package per company (off by default) and simple mode per vessel. Off hides everything and deletes nothing; on brings it back.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

async function call(path, init) {
  const { data: { session } } = await supabase.auth.getSession()
  const r = await fetch(path, { ...init, headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session?.access_token || '') } })
  const j = await r.json().catch(() => ({}))
  if (!r.ok) throw new Error(j.error || 'HTTP ' + r.status)
  return j
}
export function useServiceSwitches() {
  const [s, setS] = useState({ ready: null, packages: [], vessels: [] }), [err, setErr] = useState('')
  const load = () => call('/api/admin?resource=service_switches').then(setS).catch(e => setErr(e.message))
  useEffect(() => { load() }, [])
  const set = body => call('/api/admin', { method: 'POST', body: JSON.stringify({ action: 'service_switch_set', ...body }) }).then(load).catch(e => setErr(e.message))
  return { s, err, set }
}
export function CompanyServiceSwitch({ company, vessels, sw }) {
  const { s, set } = sw
  if (s.ready === false || s.error) return <div style={{ fontSize: 12, color: '#5b6878', marginBottom: 10 }}>Service package: {s.error || 'run sql/service-package.sql first.'}</div>
  const on = s.packages.some(p => p.company_id === company.id && p.package === 'service' && p.enabled)
  const row = id => s.vessels.find(v => v.client_id === id) || {}
  return (
    <div style={{ border: '1px solid #dde3ea', borderRadius: 10, padding: '10px 12px', marginBottom: 12 }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600 }}>
        <input type="checkbox" aria-label={'Service package for ' + company.name} checked={on} onChange={e => set({ kind: 'package', company_id: company.id, on: e.target.checked })} /> Service package
        <span style={{ fontWeight: 400, color: '#5b6878' }}>{on ? 'on' : 'off: nothing changes for this company'}</span>
      </label>
      {on && vessels.map(v => (
        <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, padding: '6px 0 0 24px', flexWrap: 'wrap' }}>
          <span style={{ minWidth: 150 }}>{v.vessel_name}</span>
          <select aria-label={'Simple mode for ' + v.vessel_name} value={row(v.id).simple_mode == null ? '' : String(row(v.id).simple_mode)} onChange={e => set({ kind: 'simple', client_id: v.id, on: e.target.value === '' ? null : e.target.value === 'true' })} style={{ padding: '4px 6px', border: '1px solid #dde3ea', borderRadius: 6 }}>
            <option value="">As its group</option><option value="true">Simple mode on</option><option value="false">Simple mode off</option>
          </select>
          <span style={{ color: '#5b6878' }}>{row(v.id).effective_simple ? 'simple mode' : 'crewed, full app'}</span>
        </div>
      ))}
    </div>
  )
}
